import { Box, Typography, UserAvatar } from "src/components";
import { useAuth } from "src/utils";

export default function ChatPreviewCard({
    chat,
    isActive,
    lastRead,
    chatUpdateTimestamp,
    onClick,
    isGroup = false
}) {
    const { user } = useAuth();

    const currentUserMessage = chat.lastMessageSentBy === user?.id;

    const isUnread = !currentUserMessage &&
        ((chat.lastMessageSentAt && (!lastRead || new Date(chat.lastMessageSentAt) > new Date(lastRead)))
        || 
        (chatUpdateTimestamp && (!lastRead || new Date(chatUpdateTimestamp) > new Date(lastRead))));
    
    return (
        <Box
            onClick={() => onClick(isGroup ? chat.id : chat.otherUserId)}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: "8px 16px",
                borderRadius: 1,
                cursor: "pointer",
                border: isActive ? "1px solid primary.main" : "1px solid transparent",
                bgcolor: isActive ? "#efefef" : "transparent",
                "&:hover": { bgcolor: "#eaeaea" },
            }}>

            <UserAvatar user={{
                id: isGroup ? chat.id : chat.otherUserId,
                name: chat?.name,
                profileImageUrl: chat?.chatImageUrl
            }} size={36} />

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ color: "#333", fontWeight: 500 }}>
                    {chat.name}
                </Typography>
                <Box sx={{ display: 'flex' }}>
                    <Typography
                        variant="body3"
                        sx={{
                            color: "text.secondary",
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                    >
                        {chat.lastMessage}
                    </Typography>
                    <Typography
                        variant="body3"
                        sx={{
                            color: "text.secondary",
                            display: "block",
                            ml: 0.5
                        }}
                    >
                        {chat.timestamp}
                    </Typography>
                </Box>
            </Box>

            {isUnread && (
                <Box
                    sx={{ 
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: 'secondary.main',
                    }}
                />
            )}
        </Box>
    );
}
